
import { useEffect } from "react";
import { useAppSelector } from "../hooks/hooks";
import { toast, ToastContainer } from 'react-toastify';

/*

Common toast for the entire application. You can call in a hook or a component to generate a toast

*/

const CommonToast = () => {
  const { toastRedux } = useAppSelector((s) => s.app);

  const getContent = (toast: {title?: string, content: string})  => {
    if (toast.title) {
      return  <div className="flex flex-column">
                <div className="font-bold mb-1">{toast.title}</div>
                <div>{toast.content}</div>
              </div>
    } else {
      return toast.content
    }
  }

  useEffect(() => {
    if (toastRedux) {
      toast(getContent(toastRedux), {type: toastRedux.severity, autoClose: toastRedux.life})
    }
  }, [toastRedux]);

  return <ToastContainer />
};

export default CommonToast;
